import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";

const ApplicationBar = (props) => {

    const { title, subtitle = '', logo, logoVariant } = props;

    const [isSubtitle, setIsSubtitle] = React.useState(false);

    React.useEffect(() => {
        if (subtitle.length > 0) {
            setIsSubtitle(true);
        }
    }, [ subtitle.length ])
    
    return (
        <>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{ flexGrow: 1, display: { xs: "flex" } }}
                        >
                            { title }
                        </Typography>

                        <Box sx={{ flexGrow: 0 }}>
                            { (!!props.logo) && 
                                <Avatar
                                    alt="Logo"
                                    src={ logo }
                                    variant={ logoVariant }
                                />
                            }
                        </Box>

                    </Toolbar>
                </Container>
            </AppBar>
         
            <Typography variant="subtitle1" sx={{ mt: 3, fontWeight: 900, display:(isSubtitle) ? 'flex' : 'none' }}>
                { subtitle }
            </Typography> 
        </>
    );
};
export default ApplicationBar;